import React from 'react';
import { useNavigate } from 'react-router-dom';

const Analytics = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-text-primary mb-4">Analytics Dashboard</h1>
          <p className="text-text-secondary">Advanced data-driven insights for your campaigns</p>
        </div>
        
        <div className="bg-white rounded-lg shadow-card p-6">
          <p className="text-text-secondary mb-4">Analytics dashboard functionality coming soon...</p>
          <button 
            onClick={() => navigate('/')}
            className="btn-primary"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default Analytics;